import { render, staticRenderFns } from "./BuyProfileFunnel.vue?vue&type=template&id=60a28f36&scoped=true"
import script from "./BuyProfileFunnel.vue?vue&type=script&lang=js"
export * from "./BuyProfileFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a28f36",
  null
  
)

export default component.exports